<template>
	<div>
		<div class="block-wrap content-wrap">
			<div class="flex">
			  <Breadcrumbs :routes="breadRoutes" />
			  <div class="search-box">
			    <input type="text" placeholder="请输入名称搜索" v-model="searchName" />
			    <div class="search-btn" @click="searchData">搜索</div>
			  </div>
			</div>
			<div class="card-list-wrap">
				<div class="card-item hand" 
							v-for="(item, index) in listData"
							:key="index"
							@click="toDetail(item)">
					<div class="card-item-img"><img :src="item.coverImg" alt=""></div>
					<div class="card-item-detail">
						<div class="card-item-detail-header">
							<h4 class="card-item-detail-header-title" :title="item.title">
								{{item.title}}
							</h4>
						</div>
						<div class="card-item-detail-body">
							{{item.briefIntroduction || '-'}}
						</div>
						<div class="card-item-detail-footer">
						  <div class="user-img" v-if="moduleId !== 'salon'"><img src="../../assets/images/about-user-img.png" alt=""></div>
						  <div class="user-name">{{item.sponsor}}</div>
						  <div class="card-more" @click="toDetail(item)">查看详情</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<Pagination :currentPage="currentPage" :total="total" @change="pageChange" />
			</div>
		</div>
	</div>
</template>

<script>
import router from "@/router";
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from "@/components/Pagination";
import tempCoverImg from '@/assets/tempImages/member-demo.jpeg';
import { getActivityList, getMeetingList, getSalonList } from "./service/api";
const routeMap = {
	activity: {
		name: '培训列表',
		api: getActivityList
	},
	meeting: {
		name: '会议列表',
		api: getMeetingList
	},
	salon: {
		name: '沙龙列表',
		api: getSalonList
	}
}
export default {
	data() {
	  return {
			searchName: '',
			moduleId: '',
	    breadRoutes: [
	      {
	        href: "/",
	        name: "首页",
	      },
	      {
	        name: "",
	      },
	    ],
	    listData: [],
	    currentPage: 1,
	    pageSize: 9,
	    total: 0,
	  };
	},
	components: {
	  Breadcrumbs,
	  Pagination
	},
	mounted() {
		this.moduleId = router.currentRoute.params.id;
		this.module = routeMap[this.moduleId]
		this.breadRoutes[1].name = this.module.name;
	  this.getList();
	},
	methods: {
		searchData() {
			this.pageChange(1);
		},
	  getList() {
	    const params = {
				title: this.searchName,
	      current: this.currentPage,
	      pageSize: this.pageSize
	    };
	    this.module.api(params).then((res) => {
	      this.total = res.totalResult;
	      this.listData = (res.list || []).map((item) => {
					item.coverImg = item.coverImg || tempCoverImg;
	        return item;
	      });
	    });
	  },
	  pageChange(page) {
	    this.currentPage = page;
			this.getList();
	  },
	  toDetail(item) {
	    router.push(`/activity/${this.moduleId}/detail?aId=${item.id}`);
	  },
	},
}
</script>

<style scoped lang="less">
@import '../../assets/less/global.less';
.content-wrap {
	padding-bottom: 80px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-box {
  height: 31px;
  display: flex;
  margin-bottom: 23px;

  input {
    width: 243px;
    height: 31px;
    background: #f1f3f3;
    border: none;
    padding: 6px 15px;
    box-sizing: border-box;
  }

  .search-btn {
    width: 95px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06ae63;
    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
.card-list-wrap {
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .card-item {
    width: 384px;
		margin-right: 24px;
    position: relative;
    display: flex;
    align-items: center;
		flex-direction: column;
		margin-bottom: 20px;

    &:nth-child(3n) {
    	margin-right: 0;
    }

    &-img {
      width: 100%;
			height: 164px;

      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    &-detail {
			width: 100%;
			height: 180px;
			background: #FDFFFD;
			border: 1px solid #E1E1E1;
      display: flex;
      flex-direction: column;
			padding: 10px 0;

      &-header {
        display: flex;
        align-items: center;
        height: 25px;
        margin-bottom: 5px;
				padding: 0 20px;

        &-title {
					&:extend(.line1);
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
					font-size: 18px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #131415;
        }
      }

      &-body {
        &:extend(.line2);
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #787878;
				line-height: 24px;
				padding: 0 20px;
				border-bottom: 1px solid #EEEEEE;
      }

      &-footer {
				padding: 0 20px;
        margin-top: auto;
        display: flex;
        height: 25px;
        align-items: center;
        
        .user-img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        
          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        
        .user-name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9D9E9E;
          margin-right: 20px;
        }
				
				.card-more {
				  width: 96px;
				  height: 32px;
				  line-height: 32px;
				  font-size: 14px;
				  font-family: PingFangSC-Regular, PingFang SC;
				  font-weight: 400;
				  color: #131415;
				  text-align: center;
				  cursor: pointer;
				  margin-left: auto;
				
				  &:hover {
				    color: #FFFFFF;
				    background: #06AE63;
				  }
				}
      }
    }
  }
}
</style>